import { render, staticRenderFns } from "./tsArticle.vue?vue&type=template&id=5f51c7cc&scoped=true"
import script from "./tsArticle.vue?vue&type=script&lang=js"
export * from "./tsArticle.vue?vue&type=script&lang=js"
import style0 from "./tsArticle.vue?vue&type=style&index=0&id=5f51c7cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f51c7cc",
  null
  
)

export default component.exports